module.exports = __webpack_public_path__ + "static/h3-904a696f786b8c39a886198e20c9f3d3.gif";